module.exports = __webpack_public_path__ + "img/MAGNA_icon.a6f6e623.png";